var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconOpenBuyBig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.853 18.861a.504.504 0 0 1 0 .713l-4.28 4.279c-.08.08-.228.127-.445.139h-.255c-.217-.012-.365-.059-.446-.139l-4.28-4.279a.504.504 0 0 1 0-.713l.714-.713a.504.504 0 0 1 .713 0L17 20.574V12.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v8.074l2.427-2.426a.504.504 0 0 1 .713 0l.713.713zm.327-10.663A10.997 10.997 0 0 1 29 17.904a11 11 0 0 1-6.566 10.069 1 1 0 1 1-.807-1.829 9.002 9.002 0 0 0 .61-16.182 1.001 1.001 0 0 1 .943-1.764zM14.302 26.11a1.001 1.001 0 0 1-.823 1.823A11 11 0 0 1 7 17.904c0-4.17 2.342-7.925 5.987-9.794a1 1 0 0 1 .913 1.78A8.997 8.997 0 0 0 9 17.903a9 9 0 0 0 5.302 8.208z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.2,
    fillRule: "nonzero",
    d: "M18 36C8.059 36 0 27.941 0 18S8.059 0 18 0s18 8.059 18 18-8.059 18-18 18zm0-1.846c8.922 0 16.154-7.232 16.154-16.154S26.922 1.846 18 1.846 1.846 9.078 1.846 18 9.078 34.154 18 34.154z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOpenBuyBig);
export default __webpack_public_path__ + "static/media/icon-open-buy-big.ba37282ad3960e500751af28262e372a.svg";
export { ForwardRef as ReactComponent };